import {
    EventbriteEvent,
    getEventDatesFormat,
    getFormattedEventDate as getFormattedEventDateStandardized,
    TimezoneLocale,
} from '@eventbrite/event-date-time';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { LoadingSkeleton } from '../../../_shared/LoadingSkeleton/LoadingSkeleton';
import { DoorTime } from './DoorTime';

const formattedEventDateStandardized = ({
    event,
    locale,
    isOnlineEvent,
}: {
    event: EventbriteEvent;
    locale: string;
    isOnlineEvent: boolean;
}) => {
    const getTimezoneFrom = isOnlineEvent
        ? TimezoneLocale.Attendee
        : TimezoneLocale.Creator;

    return getFormattedEventDateStandardized({
        event,
        locale,
        datesFormat: getEventDatesFormat({
            event,
            locale,
            useTimezoneFrom: getTimezoneFrom,
        }),
        useTimezoneFrom: getTimezoneFrom,
    });
};

interface DisplayDate {
    shouldShowDoorTime: boolean;
    doorTime?: any;
    locale: string;
    eventToShow: EventbriteEvent;
    isOnlineEvent: boolean;
}

export const DisplayDate: React.FC<DisplayDate> = ({
    shouldShowDoorTime,
    doorTime,
    locale,
    eventToShow,
    isOnlineEvent,
}) => {
    const [isLoadingUserLocalization, setIsLoadingUserLocalization] =
        useState(isOnlineEvent);
    const [formattedDateStandardized, setFormattedDateStandardized] = useState(
        () => {
            return formattedEventDateStandardized({
                event: eventToShow,
                locale,
                isOnlineEvent,
            });
        },
    );

    useEffect(() => {
        if (isOnlineEvent) {
            setFormattedDateStandardized(
                formattedEventDateStandardized({
                    event: eventToShow,
                    locale,
                    isOnlineEvent,
                }),
            );
            setIsLoadingUserLocalization(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const dateTime = shouldShowDoorTime ? (
        <div>
            <>
                {formattedDateStandardized}.{' '}
                <DoorTime
                    dateAndTimezone={{
                        utc: doorTime as string,
                        timezone: eventToShow.start.timezone,
                    }}
                    locale={locale}
                    isOnlineEvent={isOnlineEvent}
                />
            </>
        </div>
    ) : (
        formattedDateStandardized
    );

    const dateTimeClasses = classNames('date-info__full-datetime', {
        'eds-is-hidden-accessible': isLoadingUserLocalization,
    });

    return (
        <div>
            {isLoadingUserLocalization && (
                <LoadingSkeleton width="100%" borderRadius="4px" />
            )}
            <span className={dateTimeClasses}>{dateTime}</span>
        </div>
    );
};
